<template>
  <div
    v-if="preview.enabled && preview.renderData"
    class="
      sf-layer-white sf-layer-rounded sf-pad-3 sf-below-2 sf-align-c
      tw-relative
    "
  >
    <SfEchartsRenderer :graph-data="preview.renderData" height="300px" />
    <div
      v-if="preview.loading"
      class="
        tw-absolute
        tw-inset-0
        tw-flex
        tw-items-center
        tw-justify-center
        tw-bg-white/50
        tw-rounded
      "
    >
      <div class="sf-spinner sf-spinner-s" />
    </div>
  </div>

  <div
    v-else-if="preview.enabled && preview.loading"
    class="sf-layer-rounded sf-bg-snow-dark sf-pad-5 sf-level-items"
  >
    <div class="sf-level sf-level-around">
      <div class="sf-spinner sf-spinner-s" />
    </div>
  </div>

  <div
    v-else-if="preview.enabled && preview.error"
    class="
      sf-layer-rounded
      sf-bg-snow-dark
      sf-pad-5
      sf-below-2
      sf-align-c
      sf-font-s
      sf-font-medium
    "
  >
    {{ preview.error }}
  </div>

  <div
    v-else-if="!preview.enabled"
    class="
      sf-layer-rounded
      sf-bg-snow-dark
      sf-pad-5
      sf-below-2
      sf-align-c
      sf-font-s
      sf-font-medium
    "
  >
    {{ I18n.t('js.report_graph.edit.no_preview_available_info') }}
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import SfEchartsRenderer from './sf-echarts-renderer.vue'

const store = useStore()

const preview = computed(() => store.state.preview)
</script>
